import { useIntl } from 'react-intl';
import PanelCollapse from 'src/componentes/panel-collapse';

function SecaoColapsavel({ children, quantidadePerguntas, secao }) {
  const intl = useIntl();

  return (
    <PanelCollapse
      contentMarginTop={20}
      header={
        <span className="tw:flex tw:min-w-0 tw:flex-1 tw:flex-col">
          <span className="tw:m-0 tw:block tw:text-base tw:leading-5.5 tw:font-bold tw:text-[#202124]">
            {secao.titulo}
          </span>
          <span className="tw:mt-0.75 tw:block tw:text-xs tw:leading-4.5 tw:text-[#667085]">
            {quantidadePerguntas} {intl.formatMessage({ id: 'labelPerguntas' })}
          </span>
        </span>
      }
      hideShadow
      noPadding
      className="tw:mb-4! tw:rounded-[10px]! tw:border! tw:border-solid tw:border-[#d7e3e6]! tw:border-l-[3px]! tw:border-l-[#1d8b96]! tw:bg-[#fbfdfd]! tw:px-6.5! tw:pt-5.5! tw:pb-2.5!"
      headerStyle="tw:mb-0! tw:flex tw:items-center tw:p-0!"
    >
      {children}
    </PanelCollapse>
  );
}

export default SecaoColapsavel;
